export const parseSessionStorageItem = (key) => {
  const raw = sessionStorage.getItem(key);
  if (raw == null || raw === "" || raw === "undefined") return null;
  try {
    return JSON.parse(raw);
  } catch {
    return null;
  }
};
